import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import {
  TrlDashboardMobileSection,
  TrlMobileLabelValue,
  TrlSimpleFilter,
  TrlVariationLabel,
} from '»components/atoms';
import { TrlDropdown } from '»components/atoms/Inputs';
import { TrlTimeFormatted } from '»utils/date';
import { TrlFormattedMessagePlain } from '»utils/i18n';

import {
  getInstrTopGroups,
  getSelectedInstrTopGroup,
} from '../trlTopInstruments.selectors';
import { trlTopInstrumentsSlice } from '../trlTopInstruments.slice';
import {
  BoldText,
  CardTopInstrumentContainer,
  FiltersContainer,
  InstrumentsContainer,
  InstrumentsList,
  TimeStyled,
} from './TrlTopInstruments.mobile.styles';

export const TrlTopInstrumentsMobile = ({
  topInstruments,
  filters,
  selectedFilter,
  handleChangeFilter,
}) => {
  const dispatch = useDispatch();

  const instrTopGroups = useSelector(getInstrTopGroups);
  const selectedInstrTopGroup = useSelector(getSelectedInstrTopGroup);

  return (
    <TrlDashboardMobileSection
      componentId="topInstrumentsContainer"
      title={TrlFormattedMessagePlain({ id: 'TRLT_UI-TOP5' })}
      componentOrder={2}
      rightSideComponent={
        <TrlDropdown
          name="instrTopGroup"
          value={selectedInstrTopGroup}
          options={instrTopGroups}
          onChange={(data) => {
            dispatch(
              trlTopInstrumentsSlice.actions.selectInstrTopGroup({
                instrumentTopGroup: data.target.value,
              }),
            );
          }}
          isSmall
        />
      }
    >
      <InstrumentsContainer>
        <FiltersContainer>
          {filters.map(({ value, label, icon }) => (
            <TrlSimpleFilter
              key={value}
              value={value}
              icon={icon}
              label={label}
              isSelected={selectedFilter === value}
              onClick={() => handleChangeFilter(value, value)}
            />
          ))}
        </FiltersContainer>
        <InstrumentsList>
          {topInstruments.map(
            ({ symbol, descr, variationPctg, lastPx, lastDateTime }) => (
              <CardTopInstrumentContainer key={symbol}>
                <BoldText fontSize="15px">{descr}</BoldText>
                <TrlMobileLabelValue label="TRLT_UI-VARIATION">
                  <TrlVariationLabel
                    variationPctg={variationPctg}
                    parent="dashboardSmall"
                  />
                </TrlMobileLabelValue>
                <Box>
                  <BoldText fontSize="16px">{lastPx}</BoldText>
                  <TimeStyled>
                    <TrlTimeFormatted
                      value={lastDateTime}
                      hour="numeric"
                      minute="numeric"
                      second="numeric"
                    />
                  </TimeStyled>
                </Box>
              </CardTopInstrumentContainer>
            ),
          )}
        </InstrumentsList>
      </InstrumentsContainer>
    </TrlDashboardMobileSection>
  );
};

TrlTopInstrumentsMobile.propTypes = {
  topInstruments: PropTypes.array.isRequired,
  filters: PropTypes.array.isRequired,
  selectedFilter: PropTypes.string.isRequired,
  handleChangeFilter: PropTypes.func.isRequired,
};
